const getTruncatedFileName = (name: string): string => {
  if (name.length > 30) {
    const truncated: string = `${name.slice(0, 30)} ${name.slice(-8, name.length)}`
    return truncated
  }
  return name
}

export const SupportService = { getTruncatedFileName }
